(function () {
  let modalEl = null;
  let currentProduct = null;
  let selectedVariantId = null;

  function ensureModal() {
    if (modalEl) return modalEl;
    modalEl = document.getElementById('kk2-quickview-modal');
    return modalEl;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function findVariant(options) {
    return currentProduct.variants.find((v) =>
      v.options.every((val, i) => val === options[i])
    );
  }

  function render() {
    const p = currentProduct;
    const body = modalEl.querySelector('[data-kk2-qv-body]');

    let optionsHtml = '';
    p.options.forEach((optName, idx) => {
      const values = [...new Set(p.variants.map((v) => v.options[idx]))];
      optionsHtml += `<div class="kk2-qv__option">
        <p class="kk2-qv__option-label">${optName}</p>
        <div class="kk2-qv__option-values" data-kk2-qv-option="${idx}">
          ${values
            .map(
              (val) =>
                `<button type="button" class="kk2-qv__pill" data-value="${val}">${val}</button>`
            )
            .join('')}
        </div>
      </div>`;
    });

    body.innerHTML = `
      <div class="kk2-qv__media">
        <img src="${p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_700x$1$2') : ''}" alt="${p.title}">
      </div>
      <div class="kk2-qv__info">
        <h2 class="kk2-qv__title">${p.title}</h2>
        <p class="kk2-qv__price" data-kk2-qv-price>${formatMoney(p.price)}</p>
        ${optionsHtml}
        <div class="kk2-qv__actions">
          <button type="button" class="button kk2-qv__add" data-kk2-qv-add>
            Add to cart
          </button>
          <p class="kk2-qv__note" data-kk2-qv-note></p>
        </div>
        <a href="${p.url}" class="kk2-qv__full-link">View full details</a>
      </div>
    `;

    const firstAvailable = p.variants.find((v) => v.available) || p.variants[0];
    selectedVariantId = firstAvailable.id;
    firstAvailable.options.forEach((val, idx) => {
      const group = body.querySelector(`[data-kk2-qv-option="${idx}"]`);
      group?.querySelectorAll('.kk2-qv__pill').forEach((btn) => {
        btn.classList.toggle('is-selected', btn.dataset.value === val);
      });
    });
    updateAddState();
  }

  function updateAddState() {
    const variant = currentProduct.variants.find((v) => v.id === selectedVariantId);
    const addBtn = modalEl.querySelector('[data-kk2-qv-add]');
    const price = modalEl.querySelector('[data-kk2-qv-price]');
    const note = modalEl.querySelector('[data-kk2-qv-note]');
    if (!variant) return;
    price.textContent = formatMoney(variant.price);
    if (variant.available) {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to cart';
      note.textContent = '';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold out';
      note.textContent = 'This combination is currently unavailable.';
    }
  }

  async function open(handle) {
    const modal = ensureModal();
    if (!modal) return;
    modal.showModal ? modal.showModal() : modal.setAttribute('open', '');
    modal.querySelector('[data-kk2-qv-body]').innerHTML = '<div class="kk2-qv__loading">…</div>';

    const res = await fetch(`/products/${handle}.js`);
    currentProduct = await res.json();
    render();
  }

  function close() {
    if (!modalEl) return;
    modalEl.close ? modalEl.close() : modalEl.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    const modal = ensureModal();
    if (!modal) return;

    if (e.target.closest('[data-kk2-qv-close]') || e.target === modal) {
      close();
      return;
    }

    const pill = e.target.closest('.kk2-qv__pill');
    if (pill) {
      const group = pill.closest('[data-kk2-qv-option]');
      group.querySelectorAll('.kk2-qv__pill').forEach((b) => b.classList.remove('is-selected'));
      pill.classList.add('is-selected');

      const selectedOptions = [...modal.querySelectorAll('[data-kk2-qv-option]')].map((g) => {
        const sel = g.querySelector('.is-selected');
        return sel ? sel.dataset.value : null;
      });
      const match = findVariant(selectedOptions);
      if (match) {
        selectedVariantId = match.id;
        updateAddState();
      }
      return;
    }

    const addBtn = e.target.closest('[data-kk2-qv-add]');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: 1 }),
      })
        .then((r) => r.json())
        .then(() => {
          addBtn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(() => {
            close();
            updateAddState();
          }, 900);
        })
        .catch(() => {
          addBtn.disabled = false;
          addBtn.textContent = 'Try again';
        });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  window.KK2QuickView = { open, close };
})();
